import { type TagProps, Tag, TagGroup, TagList } from '@launchpad-ui/components';

type OnOffChipProps = Omit<TagProps, 'variant'> & {
  isOn: boolean;
  label?: string;
  variant?: TagProps['variant'];
};
export const OnOffChip = ({ isOn, label, variant, isDisabled, ...props }: OnOffChipProps) => {
  const chipLabel = label ?? (isOn ? 'On' : 'Off');
  const chipVariant = variant ?? (isOn ? 'success' : undefined);
  const chipDisabled = isDisabled ?? !isOn;

  return (
    <TagGroup aria-label="status">
      <TagList>
        <Tag data-test-id="on-off-chip" variant={chipVariant} isDisabled={chipDisabled} {...props}>
          {chipLabel}
        </Tag>
      </TagList>
    </TagGroup>
  );
};
